// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survey-type-management {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e5e7eb;
  transition: border-color 0.3s ease;
}

.dark .page-header {
  border-bottom-color: #424242;
}

.page-header h1 {
  margin: 0;
  color: #1f2937;
  font-size: 2rem;
  font-weight: 700;
  transition: color 0.3s ease;
}

.dark .page-header h1 {
  color: #f0f0f0;
}

.loading {
  text-align: center;
  padding: 3rem;
  color: #6b7280;
  font-size: 1.1rem;
  transition: color 0.3s ease;
}

.dark .loading {
  color: #9ca3af;
}

/* Survey Types Grid */
.survey-types-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 1.5rem;
}

.survey-type-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.dark .survey-type-card {
  background: #1e1e1e;
  border-color: #424242;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.survey-type-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.dark .survey-type-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

.survey-type-card.inactive {
  opacity: 0.6;
  background: #f9fafb;
}

.dark .survey-type-card.inactive {
  background: #151515;
  opacity: 0.5;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid #e5e7eb;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.dark .card-header {
  background: #2a2a2a;
  border-bottom-color: #424242;
}

.type-color-indicator {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.card-actions {
  display: flex;
  gap: 0.5rem;
}

.btn-icon {
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 6px;
  transition: background 0.2s ease;
  color: #374151;
}

.dark .btn-icon {
  color: #e5e7eb;
}

.btn-icon:hover {
  background: rgba(0, 0, 0, 0.1);
}

.dark .btn-icon:hover {
  background: rgba(255, 255, 255, 0.1);
}

.btn-icon.delete:hover {
  background: rgba(239, 68, 68, 0.1);
}

.card-content {
  padding: 1.5rem;
}

.card-content h3 {
  margin: 0 0 0.5rem 0;
  color: #1f2937;
  font-size: 1.25rem;
  font-weight: 600;
  transition: color 0.3s ease;
}

.dark .card-content h3 {
  color: #f0f0f0;
}

.card-content p {
  margin: 0 0 1rem 0;
  color: #6b7280;
  line-height: 1.5;
  transition: color 0.3s ease;
}

.dark .card-content p {
  color: #9ca3af;
}

.card-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.875rem;
}

.status {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-weight: 500;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status.active {
  background: #dcfce7;
  color: #166534;
}

.dark .status.active {
  background: rgba(34, 197, 94, 0.2);
  color: #86efac;
}

.status.inactive {
  background: #fee2e2;
  color: #991b1b;
}

.dark .status.inactive {
  background: rgba(239, 68, 68, 0.2);
  color: #fca5a5;
}

.date {
  color: #9ca3af;
  transition: color 0.3s ease;
}

.dark .date {
  color: #6b7280;
}

/* Button Styles */
.btn {
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.875rem;
}

.btn-primary {
  background: #667eea;
  color: white;
}

.btn-primary:hover {
  background: #5a67d8;
}

.btn-secondary {
  background: #f3f4f6;
  color: #374151;
}

.dark .btn-secondary {
  background: #374151;
  color: #e5e7eb;
}

.btn-secondary:hover {
  background: #e5e7eb;
}

.dark .btn-secondary:hover {
  background: #4b5563;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.modal {
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s ease;
}

.dark .modal {
  background: #1e1e1e;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 1.5rem 1rem 1.5rem;
  border-bottom: 1px solid #e5e7eb;
  transition: border-color 0.3s ease;
}

.dark .modal-header {
  border-bottom-color: #424242;
}

.modal-header h2 {
  margin: 0;
  color: #1f2937;
  font-size: 1.5rem;
  font-weight: 600;
  transition: color 0.3s ease;
}

.dark .modal-header h2 {
  color: #f0f0f0;
}

.btn-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #6b7280;
  padding: 0.5rem;
  line-height: 1;
  transition: color 0.3s ease;
}

.dark .btn-close {
  color: #9ca3af;
}

.btn-close:hover {
  color: #374151;
}

.dark .btn-close:hover {
  color: #e5e7eb;
}

.modal-form {
  padding: 1.5rem;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: #374151;
  font-weight: 500;
  font-size: 0.875rem;
  transition: color 0.3s ease;
}

.dark .form-group label {
  color: #e5e7eb;
}

.form-group input[type="text"],
.form-group textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.875rem;
  transition: border-color 0.2s ease, background-color 0.3s ease, color 0.3s ease;
  background: white;
  color: #1f2937;
}

.dark .form-group input[type="text"],
.dark .form-group textarea {
  background: #2a2a2a;
  border-color: #424242;
  color: #f0f0f0;
}

.form-group input[type="text"]:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.dark .form-group input[type="text"]:focus,
.dark .form-group textarea:focus {
  border-color: #90caf9;
  box-shadow: 0 0 0 3px rgba(144, 202, 249, 0.1);
}

.form-group textarea {
  resize: vertical;
  min-height: 80px;
}

.color-input-wrapper {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.color-input-wrapper input[type="color"] {
  width: 50px;
  height: 40px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.color-preview {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 2px solid #e5e7eb;
}

.checkbox-group {
  margin-bottom: 2rem;
}

.checkbox-label {
  display: flex !important;
  align-items: center !important;
  gap: 15px !important;
  cursor: pointer;
  margin: 0 !important;
  padding: 10px 0 !important;
  width: 100%;
  box-sizing: border-box;
}

.checkbox-label input[type="checkbox"] {
  width: 20px !important;
  height: 20px !important;
  min-width: 20px !important;
  min-height: 20px !important;
  accent-color: #667eea !important;
  cursor: pointer !important;
  margin: 0 !important;
  padding: 0 !important;
  vertical-align: top !important;
  flex-shrink: 0 !important;
  box-sizing: border-box !important;
  position: relative !important;
  top: 0 !important;
  left: 0 !important;
}

.checkbox-text {
  color: #374151 !important;
  font-weight: 500 !important;
  line-height: 20px !important;
  margin: 0 !important;
  padding: 0 !important;
  vertical-align: top !important;
  flex: 1 1 !important;
  display: inline-block !important;
  transition: color 0.3s ease;
}

.dark .checkbox-text {
  color: #e5e7eb !important;
}

.modal-actions {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
  transition: border-color 0.3s ease;
}

.dark .modal-actions {
  border-top-color: #424242;
}

/* Icon Grid Styles */
.icon-grid {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 5px;
  margin-top: 10px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #f9f9f9;
}

.dark .icon-grid {
  background-color: #2a2a2a;
  border-color: #424242;
}

.icon-button {
  font-size: 20px;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dark .icon-button {
  background-color: #374151;
  border-color: #4b5563;
}

.icon-button:hover {
  background-color: #f0f0f0;
}

.dark .icon-button:hover {
  background-color: #4b5563;
}

.icon-button.selected {
  background-color: #667eea !important;
}

.icon-button.selected svg {
  color: white !important;
}

.icon-button svg {
  color: black;
}

.dark .icon-button svg {
  color: #e5e7eb;
}

.icon-preview {
  font-size: 24px;
  padding: 5px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #f5f5f5;
}

.dark .icon-preview {
  background-color: #374151;
  border-color: #4b5563;
}

/* Responsive Design */
@media (max-width: 768px) {
  .survey-type-management {
    padding: 1rem;
  }

  .page-header {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }

  .page-header h1 {
    font-size: 1.5rem;
  }

  .survey-types-grid {
    grid-template-columns: 1fr;
  }

  .modal {
    margin: 1rem;
    max-width: calc(100vw - 2rem);
  }

  .modal-actions {
    flex-direction: column-reverse;
  }

  .card-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SurveyTypeManagement.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;EAChC,8DAA8D;AAChE;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kCAAkC;EAClC,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,+EAA+E;EAC/E,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;EAEE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,0BAA0B;EAC1B,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,gCAAgC;EAChC,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,8BAA8B;EAC9B,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;EAC5B,oBAAoB;EACpB,qBAAqB;EACrB,8BAA8B;EAC9B,oBAAkB;EAClB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;AACF","sourcesContent":[".survey-type-management {\n  padding: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #e5e7eb;\n  transition: border-color 0.3s ease;\n}\n\n.dark .page-header {\n  border-bottom-color: #424242;\n}\n\n.page-header h1 {\n  margin: 0;\n  color: #1f2937;\n  font-size: 2rem;\n  font-weight: 700;\n  transition: color 0.3s ease;\n}\n\n.dark .page-header h1 {\n  color: #f0f0f0;\n}\n\n.loading {\n  text-align: center;\n  padding: 3rem;\n  color: #6b7280;\n  font-size: 1.1rem;\n  transition: color 0.3s ease;\n}\n\n.dark .loading {\n  color: #9ca3af;\n}\n\n/* Survey Types Grid */\n.survey-types-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 1.5rem;\n}\n\n.survey-type-card {\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  overflow: hidden;\n  transition: all 0.2s ease;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.dark .survey-type-card {\n  background: #1e1e1e;\n  border-color: #424242;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.survey-type-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  transform: translateY(-2px);\n}\n\n.dark .survey-type-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n}\n\n.survey-type-card.inactive {\n  opacity: 0.6;\n  background: #f9fafb;\n}\n\n.dark .survey-type-card.inactive {\n  background: #151515;\n  opacity: 0.5;\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 1.5rem;\n  background: #f8fafc;\n  border-bottom: 1px solid #e5e7eb;\n  transition: background-color 0.3s ease, border-color 0.3s ease;\n}\n\n.dark .card-header {\n  background: #2a2a2a;\n  border-bottom-color: #424242;\n}\n\n.type-color-indicator {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 2px solid white;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.card-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.btn-icon {\n  background: none;\n  border: none;\n  font-size: 1.2rem;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 6px;\n  transition: background 0.2s ease;\n  color: #374151;\n}\n\n.dark .btn-icon {\n  color: #e5e7eb;\n}\n\n.btn-icon:hover {\n  background: rgba(0, 0, 0, 0.1);\n}\n\n.dark .btn-icon:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.btn-icon.delete:hover {\n  background: rgba(239, 68, 68, 0.1);\n}\n\n.card-content {\n  padding: 1.5rem;\n}\n\n.card-content h3 {\n  margin: 0 0 0.5rem 0;\n  color: #1f2937;\n  font-size: 1.25rem;\n  font-weight: 600;\n  transition: color 0.3s ease;\n}\n\n.dark .card-content h3 {\n  color: #f0f0f0;\n}\n\n.card-content p {\n  margin: 0 0 1rem 0;\n  color: #6b7280;\n  line-height: 1.5;\n  transition: color 0.3s ease;\n}\n\n.dark .card-content p {\n  color: #9ca3af;\n}\n\n.card-meta {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.875rem;\n}\n\n.status {\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-weight: 500;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status.active {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.dark .status.active {\n  background: rgba(34, 197, 94, 0.2);\n  color: #86efac;\n}\n\n.status.inactive {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.dark .status.inactive {\n  background: rgba(239, 68, 68, 0.2);\n  color: #fca5a5;\n}\n\n.date {\n  color: #9ca3af;\n  transition: color 0.3s ease;\n}\n\n.dark .date {\n  color: #6b7280;\n}\n\n/* Button Styles */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 6px;\n  font-weight: 500;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.875rem;\n}\n\n.btn-primary {\n  background: #667eea;\n  color: white;\n}\n\n.btn-primary:hover {\n  background: #5a67d8;\n}\n\n.btn-secondary {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.dark .btn-secondary {\n  background: #374151;\n  color: #e5e7eb;\n}\n\n.btn-secondary:hover {\n  background: #e5e7eb;\n}\n\n.dark .btn-secondary:hover {\n  background: #4b5563;\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.modal {\n  background: white;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  transition: background-color 0.3s ease;\n}\n\n.dark .modal {\n  background: #1e1e1e;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem 1.5rem 1rem 1.5rem;\n  border-bottom: 1px solid #e5e7eb;\n  transition: border-color 0.3s ease;\n}\n\n.dark .modal-header {\n  border-bottom-color: #424242;\n}\n\n.modal-header h2 {\n  margin: 0;\n  color: #1f2937;\n  font-size: 1.5rem;\n  font-weight: 600;\n  transition: color 0.3s ease;\n}\n\n.dark .modal-header h2 {\n  color: #f0f0f0;\n}\n\n.btn-close {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: #6b7280;\n  padding: 0.5rem;\n  line-height: 1;\n  transition: color 0.3s ease;\n}\n\n.dark .btn-close {\n  color: #9ca3af;\n}\n\n.btn-close:hover {\n  color: #374151;\n}\n\n.dark .btn-close:hover {\n  color: #e5e7eb;\n}\n\n.modal-form {\n  padding: 1.5rem;\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: #374151;\n  font-weight: 500;\n  font-size: 0.875rem;\n  transition: color 0.3s ease;\n}\n\n.dark .form-group label {\n  color: #e5e7eb;\n}\n\n.form-group input[type=\"text\"],\n.form-group textarea {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  transition: border-color 0.2s ease, background-color 0.3s ease, color 0.3s ease;\n  background: white;\n  color: #1f2937;\n}\n\n.dark .form-group input[type=\"text\"],\n.dark .form-group textarea {\n  background: #2a2a2a;\n  border-color: #424242;\n  color: #f0f0f0;\n}\n\n.form-group input[type=\"text\"]:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.dark .form-group input[type=\"text\"]:focus,\n.dark .form-group textarea:focus {\n  border-color: #90caf9;\n  box-shadow: 0 0 0 3px rgba(144, 202, 249, 0.1);\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.color-input-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.color-input-wrapper input[type=\"color\"] {\n  width: 50px;\n  height: 40px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.color-preview {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  border: 2px solid #e5e7eb;\n}\n\n.checkbox-group {\n  margin-bottom: 2rem;\n}\n\n.checkbox-label {\n  display: flex !important;\n  align-items: center !important;\n  gap: 15px !important;\n  cursor: pointer;\n  margin: 0 !important;\n  padding: 10px 0 !important;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  width: 20px !important;\n  height: 20px !important;\n  min-width: 20px !important;\n  min-height: 20px !important;\n  accent-color: #667eea !important;\n  cursor: pointer !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  vertical-align: top !important;\n  flex-shrink: 0 !important;\n  box-sizing: border-box !important;\n  position: relative !important;\n  top: 0 !important;\n  left: 0 !important;\n}\n\n.checkbox-text {\n  color: #374151 !important;\n  font-weight: 500 !important;\n  line-height: 20px !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  vertical-align: top !important;\n  flex: 1 !important;\n  display: inline-block !important;\n  transition: color 0.3s ease;\n}\n\n.dark .checkbox-text {\n  color: #e5e7eb !important;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: flex-end;\n  padding-top: 1rem;\n  border-top: 1px solid #e5e7eb;\n  transition: border-color 0.3s ease;\n}\n\n.dark .modal-actions {\n  border-top-color: #424242;\n}\n\n/* Icon Grid Styles */\n.icon-grid {\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  gap: 5px;\n  margin-top: 10px;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background-color: #f9f9f9;\n}\n\n.dark .icon-grid {\n  background-color: #2a2a2a;\n  border-color: #424242;\n}\n\n.icon-button {\n  font-size: 20px;\n  padding: 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background-color: white;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.dark .icon-button {\n  background-color: #374151;\n  border-color: #4b5563;\n}\n\n.icon-button:hover {\n  background-color: #f0f0f0;\n}\n\n.dark .icon-button:hover {\n  background-color: #4b5563;\n}\n\n.icon-button.selected {\n  background-color: #667eea !important;\n}\n\n.icon-button.selected svg {\n  color: white !important;\n}\n\n.icon-button svg {\n  color: black;\n}\n\n.dark .icon-button svg {\n  color: #e5e7eb;\n}\n\n.icon-preview {\n  font-size: 24px;\n  padding: 5px 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background-color: #f5f5f5;\n}\n\n.dark .icon-preview {\n  background-color: #374151;\n  border-color: #4b5563;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .survey-type-management {\n    padding: 1rem;\n  }\n\n  .page-header {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: stretch;\n  }\n\n  .page-header h1 {\n    font-size: 1.5rem;\n  }\n\n  .survey-types-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .modal {\n    margin: 1rem;\n    max-width: calc(100vw - 2rem);\n  }\n\n  .modal-actions {\n    flex-direction: column-reverse;\n  }\n\n  .card-meta {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
